module.exports = __webpack_public_path__ + "img/confirmation.eb5ebcdb.png";